<template>
  <div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
    style="overflow: hidden;">
    <div class="m-portlet m-portlet--mobile">
      <SearchTitle label='出科审核' url='/cycle/out/outcheckmanage'></SearchTitle>
      <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
        <div class="m-form m-form--label-align-right">
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">管理单元：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.secretarysec" filterable placeholder="全部" @change="ManageSecChange">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in managesecOptions" :key="item.DictItemID" :label="item.DictItemName"
                    :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">轮转科室：</label>
              </div>
              <div class="m-form__control">
                <el-select v-model="condition.section" filterable placeholder="全部">
                  <el-option label="全部" value=""></el-option>
                  <el-option v-for="item in secOptions" :key="item.DictItemID" :label="item.DictItemName"
                    :value="item.DictItemID">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <SearchNormalText v-model='condition.truename' label='姓名'></SearchNormalText>
          <SearchNormalText v-model='condition.cardno' label='工号'></SearchNormalText>
          <ZPGLSearchDictItemSelect v-model='condition.specialty' label='专业' :dictid='this.$utils.DictEnum.specialty'>
          </ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">出科时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.outdate" type="month" placeholder="出科时间" value-format="yyyy-MM">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">考核时间：</label>
              </div>
              <div class="m-form__control">
                <el-date-picker v-model="condition.examdate" type="date" placeholder="考核时间" value-format="yyyy-MM-dd">
                </el-date-picker>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
          <ZPGLSearchDictItemSelect v-model='condition.examtime' label='时间段' :dictid='this.$utils.DictEnum.examtime'>
          </ZPGLSearchDictItemSelect>
          <div style="float: left;margin-top: 10px;">
            <div class="m-form__group m-form__group--inline">
              <div class="m-form__label">
                <label style="width: 100px;text-align:right;">视图类型：</label>
              </div>
              <div class="m-form__control" style="height: 40px;line-height: 40px;">
                <el-radio-group v-model="viewtype" @change="ViewTypeChange">
                  <el-radio label="1">常规视图</el-radio>
                  <el-radio label="2">日期视图</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="d-md-none m--margin-bottom-10"></div>
          </div>
        </div>
        <div style="clear: both;"></div>
        <div class="m--margin-top-10 m--margin-bottom-10" style="width: 100%;text-align: center;">
          <!-- <SearchButton :url='searchUrl' ref="btnSearch"></SearchButton> -->
          <el-button type="primary" icon="el-icon-search" @click="Search(1)">查询</el-button>
    <!--      <el-button type="primary" icon="el-icon-edit" @click="DelayOutApply()">延期人员审核</el-button> -->
          <el-button type="primary" icon="el-icon-check" @click="MultipleCheck(2)">批量审核通过</el-button>
          <el-button type="danger" icon="el-icon-close" @click="ShowCheckInfo=true">批量审核不通过</el-button>
        </div>
        <!--end: Search Form -->
        <div class="m-portlet__body" style="padding: .2rem 2.2rem;">
          <!--begin: Datatable -->
          <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" v-show="viewtype == 1"
            size="medium" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column>
              <template slot="header">
                姓名<br>工号
              </template>
              <template slot-scope="scope">
                {{scope.row.CPStuName}}<br>{{scope.row.CPStuNo}}
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                专业<br>用户类型
              </template>
              <template slot-scope="scope">
                {{scope.row.StuSpecName}}<br>{{scope.row.StuSpecName}}
              </template>
            </el-table-column>
            <el-table-column prop="CPManageSecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="CPSecName" label="轮转科室">
            </el-table-column>
            <el-table-column label="轮转时间" width="240">
              <template slot-scope="scope">
                {{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
              </template>
            </el-table-column>
            <el-table-column label="考核时间" width="240">
              <template slot-scope="scope">
                <div v-if="scope.row.ExamType == '1'">
                  {{scope.row.ExamDate|formatFullDate}} <br> {{scope.row.ExamTimeName}}
                </div>
                <div v-if="scope.row.ExamType == '2'">
                  -
                </div>
              </template>
            </el-table-column>
            <el-table-column label="出科考核状态">
              <template slot-scope="scope">
                <span style="color: #409EFF;" v-if="scope.row.ExamType=='1'">{{scope.row.ExamTypeName}}</span>
                <span style="color: #F56C6C;" v-if="scope.row.ExamType=='2'">{{scope.row.ExamTypeName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="ScoreInfo(scope.row)">审核</el-button>
              </template>
            </el-table-column>
          </el-table>
          <!--end: Datatable -->
          <el-table :data="tableExamDateData" style="width: 100%" v-show="viewtype == 2" size="medium">
            <el-table-column fixed label="预约场次" width="150">
              <template slot-scope="scope">
                {{scope.row.ExamTimeName}}
              </template>
            </el-table-column>
            <el-table-column width="160" v-for="col in cols" :label="col.label" v-bind:key="col.prop">
              <template slot-scope="scope">
                <!-- <span v-for="(info,index) in scope.row[col.prop].split('、')" v-bind:key="index">info</span> -->
                <div v-html="formatInfo(scope.row[col.prop])"></div>
              </template>
            </el-table-column>
          </el-table>
          <el-table v-loading="loading" :data="tableLeaveData" stripe style="width: 100%;margin-top: 30px;"
            v-show="viewtype == 2" size="medium">
            <el-table-column>
              <template slot="header">
                姓名<br>工号
              </template>
              <template slot-scope="scope">
                {{scope.row.CPStuName}}<br>{{scope.row.CPStuNo}}
              </template>
            </el-table-column>
            <el-table-column>
              <template slot="header">
                专业<br>用户类型
              </template>
              <template slot-scope="scope">
                {{scope.row.StuSpecName}}<br>{{scope.row.StuSpecName}}
              </template>
            </el-table-column>
            <el-table-column prop="CPManageSecName" label="管理单元">
            </el-table-column>
            <el-table-column prop="CPSecName" label="轮转科室">
            </el-table-column>
            <el-table-column label="轮转时间" width="240">
              <template slot-scope="scope">
                {{scope.row.CPBeginDate|formatFullDate}} 至 {{scope.row.CPEndDate|formatFullDate}}
              </template>
            </el-table-column>
            <el-table-column label="考核时间" width="240">
              <template slot-scope="scope">
                <div v-if="scope.row.ExamType == '1'">
                  {{scope.row.ExamDate|formatFullDate}} <br> {{scope.row.ExamTimeName}}
                </div>
                <div v-if="scope.row.ExamType == '2'">
                  -
                </div>
              </template>
            </el-table-column>
            <el-table-column label="出科考核状态">
              <template slot-scope="scope">
                <span style="color: #409EFF;" v-if="scope.row.ExamType=='1'">{{scope.row.ExamTypeName}}</span>
                <span style="color: #F56C6C;" v-if="scope.row.ExamType=='2'">{{scope.row.ExamTypeName}}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="80">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="ScoreInfo(scope.row)">审核</el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="margin-top: 10px;text-align: center;" v-if="this.condition.recordCount > 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
              :current-page="condition.currentPage" :page-sizes="[2, 10, 20, 30, 40]" :page-size="condition.pageSize"
              layout="total, sizes, prev, pager, next, jumper" :total="condition.recordCount">
            </el-pagination>
          </div>
          <el-dialog width="30%" title="出科申请审核" :visible.sync="socreInfoVisible">
            <el-form class="m-form m-form--fit m-form--label-align-right m-form--group-seperator-dashed"
              :model="infoform">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="姓名:">
                    {{infoform.CPStuName}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="轮转科室:">
                    {{infoform.CPSecName}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="轮转时间:">
                    {{infoform.CPDate}}
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="考核类型:">
                    <span style="color: #409EFF;" v-if="infoform.ExamType=='1'">{{infoform.ExamTypeName}}</span>
                    <span style="color: #F56C6C;" v-if="infoform.ExamType=='2'">{{infoform.ExamTypeName}}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <div v-if="infoform.ExamType=='2'">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="延期原因:">
                      <span>{{infoform.DelayReason}}</span>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <div v-if="infoform.ExamType=='1'">
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="考官1:">
                      {{infoform.TecName1}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="考官2:">
                      {{infoform.TecName2}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="考官3:">
                      {{infoform.TecName3}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="预约时间:">
                      {{infoform.OutApplyDate}}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="24">
                    <el-form-item label="考核科目:">
                      {{infoform.projectname}}
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="审核结果:">
                    <el-radio v-model="CheckResult" label="2">通过</el-radio>
                    <el-radio v-model="CheckResult" label="3">不通过</el-radio>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="CheckResult==3">
                <el-col :span="24">
                  <el-form-item label="审核意见:">
                    <el-input v-model="infoform.checkinfo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer" style="">
              <el-button type="success" @click="Check" v-loading.fullscreen.lock="fullscreenLoading">保 存</el-button>
              <!-- <el-button type="danger" @click="Check(3)" v-loading.fullscreen.lock="fullscreenLoading">不通过</el-button> -->
            </div>
          </el-dialog>
          <el-dialog title="审核意见" :visible.sync="ShowCheckInfo">
            <el-form>
              <el-form-item label="审核意见" :label-width="formLabelWidth">
                <el-input v-model="infoform.checkinfo" autocomplete="off"></el-input>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="MultipleCheck(3)">确 定</el-button>
            </div>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'OutManage',
    data() {
      return {
        condition: {
          token: '',
          username: '',
          rolelevel: '',
          secretarysec: '',
          section: '',
          truename: '',
          cardno: '',
          specialty: '',
          outdate: '',
          outstatus: '1',
          pageSize: 10,
          currentPage: 1,
          recordCount: 0,
          firstSearch: true,
          viewtype: '1',
          examtype: '',
          examdate: ''
        },
        viewtype: '1',
        infoform: {
          token: '',
          oaid: '',
          cpid: '',
          CPStuName: '',
          CPSecName: '',
          CPDate: '',
          TecID1: '',
          TecID2: '',
          TecID3: '',
          TecName1: '',
          TecName2: '',
          TecName3: '',
          OutApplyDate: '',
          checkinfo: '',
          checkstatus: '',
          ExamTypeName: '',
          ExamType: '',
          DelayReason: '',
          oaids: ''
        },
        searchUrl: this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyList',
        managesecOptions: [],
        secOptions: [],
        tableData: [],
        tableExamDateData: [],
        tableLeaveData: [],
        cols: [],
        socreInfoVisible: false,
        loading: true,
        fullscreenLoading: false,
        CheckResult: '2',
        ShowCheckInfo: false
      }
    },
    filters: {
      formatDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        return y + '-' + (m < 10 ? '0' + m : m)
      },
      formatFullDate(val) {
        var now = new Date(val)
        var y = now.getFullYear()
        var m = now.getMonth() + 1
        var d = now.getDate()
        return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d)
      }
    },
    created() {
      window.ExamDateScoreInfo = this.ExamDateScoreInfo
    },
    methods: {
      handleSelectionChange: function(val) {
        this.infoform.oaids = ''
        val.forEach((item, index) => {
          if (index > 0) {
            this.infoform.oaids += ','
          }
          this.infoform.oaids += item.OAID
        })
      },
      DelayOutApply: function() {
        this.$router.push('/main/cycle/out/delayoutapplycheckmanage')
      },
      // 调整每页显示数
      handleCurrentChange: function(val) {
        this.condition.firstSearch = false
        this.condition.currentPage = val
        this.Search()
      },
      // 分页操作
      handleSizeChange: function(val) {
        this.condition.firstSearch = false
        this.condition.pageSize = val
        this.condition.currentPage = 1
        this.Search()
      },
      ViewTypeChange: function() {
        this.Search(1)
      },
      Search: function(pageindex) {
        this.GetDaysInMonth()

        if (this.viewtype == 2) {
          this.condition.viewtype = 2
        } else {
          this.condition.viewtype = 1
          this.condition.examtype = ''
        }

        if (pageindex != null) {
          this.condition.currentPage = pageindex
        }
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyList', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              console.log(res.data.Data)
              if (that.viewtype == 1) {
                that.tableData = res.data.Data
              } else {
                that.tableExamDateData = res.data.Data
                that.LoadLeaveData()
              }
              that.condition.recordCount = res.data.Pager.RecordCount
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            that.loading = false
          })
          .catch(err => {
            that.tableData = []
            that.tableExamDateData = []
            that.condition.recordCount = 0
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
            that.loading = false
          })
      },
      LoadLeaveData: function() {
        this.condition.currentPage = 1
        this.condition.viewtype = 1
        this.condition.examtype = 2
        var that = this
        this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyList', this.condition)
          .then(res => {
            if (res.data.Code === 0) {
              that.tableLeaveData = res.data.Data
              that.condition.recordCount = res.data.Pager.RecordCount
            } else {
              that.$message({
                message: res.data.Msg + '，' + res.data.Error,
                type: 'error'
              })
            }
            that.loading = false
          })
          .catch(err => {
            that.tableLeaveData = []
            that.condition.recordCount = 0
            console.log(err)
            that.$message({
              message: '查询失败',
              type: 'error'
            })
            that.loading = false
          })
      },
      formatInfo: function(val) {
        var info = ''
        if (val != null) {
          var outapplyinfos = val.split('、')
          for (var i = 0; i < outapplyinfos.length; i++) {
            var oainfo = outapplyinfos[i].split('|')
            var text = '<span style=\'cursor: pointer;color:#66b1ff;\' onclick="ExamDateScoreInfo(' + oainfo[1] +
              ')">' + oainfo[0] + '</span>'
            if ((i + 1) % 3 == 0) {
              if (i == 0) {
                info += text + '、'
              } else {
                if (i == outapplyinfos.length - 1) {
                  info += text + '、'
                } else {
                  info += text + '<br>'
                }
              }
            } else {
              info += text + '、'
            }
          }
          info = info.substring(0, info.length - 1)
        }
        return info
      },
      GetDaysInMonth: function() {
        this.cols = []
        var date = new Date(this.condition.outdate)
        var year = date.getFullYear()
        var month = date.getMonth() + 1

        month = parseInt(month, 10)
        const lastDayOfMonth = new Date(year, month, 0).getDate()
        for (let i = 1; i <= lastDayOfMonth; i++) {
          var str = year + "-" + (month < 10 ? '0' + month : month) + "-" + (i < 10 ? '0' + i : i)
          var arg = {
            prop: str,
            label: str
          }
          this.cols.push(arg)
        }
      },
      LoadManageSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/ManageSecionList', args, function(data) {
          that.managesecOptions = data.Data
          that.Search(1)
        }, null, null, null)
      },
      ManageSecChange: function() {
        this.condition.section = ''
        this.secOptions = []
        this.LoadCPSec()
      },
      LoadCPSec: function() {
        var args = {
          token: this.condition.token,
          username: this.condition.username,
          rolelevel: this.condition.rolelevel,
          mamagesec: this.condition.secretarysec
        }
        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIDictItem/CPSecList', args, function(data) {
          that.secOptions = data.Data
        }, null, null, null)
      },
      ExamDateScoreInfo: function(val) {
        console.log(val)
        this.infoform.cpid = val
        var args = {
          token: this.condition.token,
          cpid: val
        }

        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadOutApplyScore', args, function(data) {
          var info = data.Data
          that.infoform.CPStuName = info.CPStuName
          that.infoform.CPSecName = info.CPSecName
          that.infoform.ExamTypeName = info.ExamTypeName
          that.infoform.ExamType = info.ExamType

          var date = new Date(info.CPBeginDate)
          var y = date.getFullYear()
          var m = date.getMonth() + 1
          var d = date.getDate()
          var begindate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

          date = new Date(info.CPEndDate)
          y = date.getFullYear()
          m = date.getMonth() + 1
          d = date.getDate()
          var enddate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

          that.infoform.CPDate = begindate + ' - ' + enddate

          date = new Date(info.ExamDate)
          y = date.getFullYear()
          m = date.getMonth() + 1
          d = date.getDate()

          that.infoform.OutApplyDate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d) +
            ' ' + info.ExamTimeName

          that.infoform.projectname = info.ProjectName

          that.LoadOutApplyScoreTecInfo(that.infoform.cpid)
        }, null, null, null)
      },
      ScoreInfo: function(row) {
        var args = {
          token: this.condition.token,
          oaid: row.OAID,
          oatype: 0
        }

        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/LoadOutApplyScore', args, function(data) {
          var info = data.Data
          that.infoform.oaid = info.OAID
          that.infoform.CPStuName = info.CPStuName
          that.infoform.CPSecName = info.CPSecName
          that.infoform.ExamTypeName = info.ExamTypeName
          that.infoform.ExamType = info.ExamType
          that.infoform.DelayReason = info.DelayReason

          var date = new Date(info.CPBeginDate)
          var y = date.getFullYear()
          var m = date.getMonth() + 1
          var d = date.getDate()
          var begindate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

          date = new Date(info.CPEndDate)
          y = date.getFullYear()
          m = date.getMonth() + 1
          d = date.getDate()
          var enddate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d)

          that.infoform.CPDate = begindate + ' - ' + enddate

          date = new Date(info.ExamDate)
          y = date.getFullYear()
          m = date.getMonth() + 1
          d = date.getDate()

          that.infoform.OutApplyDate = y + '/' + (m < 10 ? '0' + m : m) + '/' + (d < 10 ? '0' + d : d) +
            ' ' + info.ExamTimeName

          that.infoform.projectname = info.ProjectName

          that.LoadOutApplyScoreTecInfo(that.infoform.oaid)
        }, null, null, null)

      },
      LoadOutApplyScoreTecInfo: function(OAID) {
        var args = {
          token: this.condition.token,
          oaid: OAID
        }

        var that = this
        this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APICyclePlan/OutApplyTecInfo', args, function(data) {
          var list = data.Data
          for (var i = 0; i < list.length; i++) {
            if (i == 0) {
              that.infoform.TecName1 = list[i].TecName + '(' + list[i].TecNo + ')'
            } else if (i == 1) {
              that.infoform.TecName2 = list[i].TecName + '(' + list[i].TecNo + ')'
            } else if (i == 2) {
              that.infoform.TecName3 = list[i].TecName + '(' + list[i].TecNo + ')'
            }
          }
          that.socreInfoVisible = true
        }, null, null, null)
      },
      Check: function() {
        var checkmessage = ''
        if (this.CheckResult == '2') {
          checkmessage = '审核通过'
          this.infoform.checkinfo = '' //审核通过，意见为空
        } else {
          checkmessage = '审核不通过'
        }
        this.$confirm('确定' + checkmessage + '该出科申请?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = true
          this.infoform.checkstatus = this.CheckResult
          var that = this
          this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/CheckOutApply', this.infoform)
            .then(res => {
              console.log(res.data)
              if (res.data.Code === 0) {
                that.$message({
                  message: '审核成功',
                  type: 'success'
                })
                that.socreInfoVisible = false
                that.Search()
              } else {
                that.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
              that.fullscreenLoading = false
            })
            .catch(err => {
              console.log(err)
              that.$message({
                message: '审核失败',
                type: 'error'
              })
              that.fullscreenLoading = false
            })
        }).catch(() => {})
      },
      //批量审核数据
      MultipleCheck: function(checkstate) {
        let that = this
        let checkmsg = checkstate == 2 ? '批量审核通过？' : '批量审核不通过？'
        this.$confirm(checkmsg, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.fullscreenLoading = true
          this.infoform.checkstatus = checkstate
          this.$http.post(this.$utils.Url.zpgl + '/api/APICyclePlan/MultipleCheckOutApply', this.infoform)
            .then(res => {
              if (res.data.Code === 0) {
                that.$message({
                  message: '审核成功',
                  type: 'success'
                })
                that.Search()
              } else {
                that.$message({
                  message: res.data.Msg + '，' + res.data.Error,
                  type: 'error'
                })
              }
              that.ShowCheckInfo=false
              that.fullscreenLoading = false
            })
        })
      }
    },
    mounted: function() {
      this.condition.token = sessionStorage.getItem('token')
      this.infoform.token = sessionStorage.getItem('token')
      this.condition.username = sessionStorage.getItem('username')
      this.condition.rolelevel = sessionStorage.getItem('rolelevel')
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      if (month > 12) {
        year = year + 1
        month = 1
      }
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      this.condition.outdate = year + '-' + month
      this.LoadManageSec()
    }
  }
</script>

<style scoped="scoped">
  .message-box {
    width: 600px;
  }

  .timeclass {
    width: 100%;
  }

  /deep/.el-table .cell {
    line-height: 25px;
  }

  /deep/.el-input {
    width: 220px;
  }

  .el-form-item {
    margin-bottom: 0px;
  }

  /deep/.el-table__header-wrapper {
    width: 100%;
  }
</style>
